import { onRequestModuleCommand } from 'owa-calendar-module-command';
import { unlockSelectedItem } from 'owa-calendar-surface-dategrid';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { orchestrator } from 'satcheljs';

orchestrator(onRequestModuleCommand, actionMessage => {
    // unlock the selected item once the peek has successfully opened.
    if (
        actionMessage.moduleCommand == 'Open_ItemPeek' ||
        actionMessage.moduleCommand == 'Open_ReadPanel' ||
        actionMessage.moduleCommand == 'Open_QuickCompose' ||
        actionMessage.moduleCommand == 'Open_MobilityCompose'
    ) {
        unlockSelectedItem(getSurfaceStore());
    }
});
